// extracted by mini-css-extract-plugin
export var bd = "ar-j";
export var bigger = "ar-m";
export var detail = "ar-l";
export var downloadBar = "ar-i";
export var footBottom = "ar-h";
export var footBottomDesc = "ar-o";
export var footLine = "ar-f";
export var footTop = "ar-c";
export var footTopAddress = "ar-g";
export var footTopDesc = "ar-d";
export var footTopText = "ar-e";
export var footerM = "ar-b";
export var ft = "ar-p";
export var logo = "ar-k";
export var minWidthLimit = "ar-a";
export var red = "ar-n";